export const borderColor = `#666666`;

export const linkColor = `#a2a2a2`;
